<template>
    <div>
        
        
       <div class="text-center">
            <h3 class="mb-3">{{$t('fxRiskPercentage')}} </h3>
            <p>{{$t('fxOffersRiskCalculator')}}</p>
       </div>
        <div class="verticallyTab mt-5"> 
            <div class="bottomTab w-100">
                <form class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field">
                                    <option>USD</option>
                                    <option>ETH</option>
                                    <option>BTC</option>
                                    <option>LTC</option>
                                    <option>BCC</option>
                                    <option>XRP</option>
                                </select>
                                <label class="float-label">{{$t('fxAccountBaseCurrency')}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field">
                                    <option>{{$t('fxCryptoCurrencies')}}</option>
                                    <option>{{$t('fxCurrencies')}}</option>
                                    <option>{{$t('fxCommodities')}}</option>
                                    <option>{{$t('fxIndices')}}</option>
                                </select>
                                <label class="float-label">{{$t('fxCurrencyPairs')}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">{{$f('fxOpenPrice')}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper text-left">
                                <label class="float-label-custom">{{$t('fxDealType')}}</label>
                                <div class="d-flex align-items-center">
                                    <label class="custom-radio-button">{{$t('fxBuy')}}
                                        <input type="radio" name="radio">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="custom-radio-button">{{$t('fxSell')}}
                                        <input type="radio" name="radio">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">{{$t('fxStopLoss')}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">{{$t('fxAccountBalance')}} </label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" name="username" class="float-field">
                                <label class="float-label">{{$t('fxRiskPercentage')}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn">{{$t('fxCalculateNow')}}</a>
                                <p class="mt-3">{{$t(fxCommisionRoundTrip)}}</p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        
        <ul class="listResult d-flex flex-wrap text-left">
            <li>
                <p>{{$t('fxSegment')}}</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>{{$t('fxAccountBaseCurrency')}}</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>{{$t('fxSymbol')}}</p>
                <h4>EURUSD</h4>
            </li>
            <li>
                <p>{{$t('fxVolumeLots')}}</p>
                <h4>500</h4>
            </li>
            <li>
                <p>{{$t('fxCurrentConversionPrice')}}</p>
                <h4>0.0</h4>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'RiskPercentage',
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/risk_percentage.vue